import {Alert} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {orderLabel} from 'src/jobs/order-plus/order-label'
import {OrderPageFrame} from 'src/jobs/order-plus/order-page-frame'
import {validateOrderPlusSearch} from 'src/jobs/order-plus/order-plus-search'
import {ServiceVisitsPage} from 'src/jobs/order-plus/service-visits-page'

export const Route = createFileRoute('/_app/projects/$projectId/service-visits')({
    validateSearch: validateOrderPlusSearch,
    component: ServiceVisitsRoute,
})

function ServiceVisitsRoute() {
    const {projectId} = Route.useParams()
    const {from} = Route.useSearch()
    return (
        <OrderPageFrame
            projectId={projectId}
            title={(order) => `Service visits for order ${orderLabel(order)}`}
            description="Recurring visits as jobs in this order."
        >
            {(order, {canEdit}) =>
                from ? (
                    <ServiceVisitsPage
                        projectId={projectId}
                        orderLabel={orderLabel(order)}
                        sourceJobId={from}
                        readOnly={!canEdit}
                    />
                ) : (
                    <Alert color="yellow">Open + Service visits from a job of this order.</Alert>
                )
            }
        </OrderPageFrame>
    )
}
